import { useLingui } from '@lingui/react/macro';
import { Box } from '@mui/material';
import { makeStyles } from '@mui/styles';

import {
  blue100,
  blueBlack630,
  white,
} from '../../../theme/videa-style-tokens';
import { useUniversalToFDI } from '../../../utils/internationalization/useUniversalToFDI';
import { findRBLAnnotationIndex } from '../../../utils/rbl';
import { VideaTypography } from '../../elements/VideaTypography/VideaTypography';

const useStyles = makeStyles((theme) => ({
  pop: {
    color: white,
    backgroundColor: blueBlack630,
  },
  p1Left: {
    paddingLeft: theme.spacing(1),
  },
  toothNumberInput: {
    fontSize: '14px',
    fontWeight: 'normal',
    color: blue100,
    height: '15px',
    textAlign: 'center',
    paddingLeft: '5px',
  },
  toothNumberInputUnassigned: {
    fontSize: '14px',
    fontWeight: 'lighter',
    color: blue100,
    width: '30px',
    height: '15px',
    textAlign: 'center',
  },
  textFieldWrapper: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'baseline',
  },
}));

export const RblPopup = (props: any) => {
  const { rblFindings, finding, isPAImage } = props;
  const classes = useStyles();
  const { displayToothNumber } = useUniversalToFDI();
  const { t, i18n } = useLingui();

  const rblAnnotationIndex = findRBLAnnotationIndex(finding?.id, rblFindings);
  const rblParentFinding = rblFindings[rblAnnotationIndex[0]];
  const rblToothSideFinding = rblParentFinding?.sides[rblAnnotationIndex[1]];

  const toothNumber = rblParentFinding?.toothNumber;

  const distance = rblToothSideFinding?.distanceMM;
  const rblLineLengthIndication = finding.rblType === 'root' ? null : distance;
  const measurementType = isPAImage ? ' (%)' : ' (mm)';

  const hasValidMeasurement =
    rblLineLengthIndication !== null &&
    !Number.isNaN(parseInt(rblLineLengthIndication, 10));

  const formatRblTypeString = (rblFinding: any) => {
    const findingType = rblFinding.rblType;

    const typeTextMap = {
      cej: t`CEJ`,
      abd: t`ABL`,
      root: t`root tip`,
    };

    // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    return typeTextMap[findingType] ?? findingType;
  };

  const getSideText = (side: string) => {
    if (side === 'mesial') {
      return t`mesial`;
    }
    if (side === 'distal') {
      return t`distal`;
    }
    return t`Unknown`;
  };

  const shouldDisplayToothSide = (rblFinding: any) => {
    if (
      finding.rblType === 'root' &&
      rblParentFinding?.sides[2]?.points?.length !== 0
    ) {
      return false;
    }
    return !!rblFinding?.side;
  };

  const rblPointPopup = [
    {
      key: t`Tooth #`,
      value: displayToothNumber(toothNumber),
      isVisible: true,
    },
    {
      key: t`Point`,
      value: formatRblTypeString(finding),
      isVisible: !!finding.rblType,
    },
    {
      key: t`Measurement ${measurementType}`,
      value: hasValidMeasurement
        ? i18n.number(rblLineLengthIndication)
        : t`N/A (no root tip)`,
      isVisible: finding.rblType !== 'root',
    },
    {
      key: t`Side`,
      value:
        rblToothSideFinding?.side === 'Undefined'
          ? t`Unknown`
          : getSideText(rblToothSideFinding?.side),
      isVisible: shouldDisplayToothSide(rblToothSideFinding),
    },
  ];

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="flex-start"
      className={classes.pop}
    >
      {rblPointPopup.map(
        (rblPointInfo) =>
          rblPointInfo.isVisible && (
            <div className={classes.textFieldWrapper} key={rblPointInfo.key}>
              <VideaTypography
                variant="bodyExtrasmall"
                className={classes.p1Left}
              >
                {rblPointInfo.key}:
              </VideaTypography>
              <div>
                <VideaTypography
                  variant="bodyExtrasmall"
                  className={classes.toothNumberInput}
                >
                  {rblPointInfo.value}
                </VideaTypography>
              </div>
            </div>
          ),
      )}
    </Box>
  );
};
